export default "__VITE_ASSET__21dd4011__"